import axios, { AxiosRequestConfig } from "axios";

import { OfflineOrganization } from "./../offline/organization";
const organization = new OfflineOrganization();

import { OfflineIndex } from "./../offline";
const offline = new OfflineIndex();

export class AuthApi {
  async getUser() {
    let path = `api/user/GetUserLogin`;

    try {
      if (window.isOffline) {
        return await offline.getUserLogin();
      } else {
        const response = await axios.get(path);
        return response.data;
      }
    } catch (error) {
      console.error(`Error get user login`, error);
      throw error;
    }
  }

  async getCurrentSaleOrg() {
    let path = `api/User/GetCurrentSaleOrg`;

    try {
      if (window.isOffline) {
        return await offline.getSaleOrgs();
      } else {
        const response = await axios.get(path);
        return response.data;
      }
    } catch (error) {
      console.error(`Error get user login`, error);
      throw error;
    }
  }

  async fetchOrganize(company?: string | null, channel?: string | null, sale?: string | null) {
    let path = `api/user/ShowPopUpSelectCompany`;
    if (window.isOffline) {
      let data = await organization.chainFetch(company, channel, sale);
      return data;
    } else {
      let config: AxiosRequestConfig = {
        params: {},
      };
      if (company) {
        config.params["companySelected"] = company;
      }
      if (channel) {
        config.params["channelSelected"] = channel;
      }
      if (sale) {
        config.params["saleOrgSelected"] = sale;
      }

      try {
        const response = await axios.get(path, config);
        return response.data;
      } catch (error) {
        console.error(`Error fetch organize`, error);
        throw error;
      }
    }
  }

  async updateOrganize(company: string, channel: string, sale: number, center: number) {
    if (window.isOffline) {
      // let data = await organization.setOrg(company, channel, sale, center);
      // return data;
    } else {
      try {
        const response = await axios.post(`/api/DashBoard/SelectOrgForViewReport?channelSelected=${channel}&companySelected=${company}&saleOrgId=${sale}&saleOrgMasterCenterId=${center}`);
        return response.data;
      } catch (error) {
        console.error(`Error update organize`, error);
        throw error;
      }
    }
  }

  async getSaleOrgCenter(params: { SaleOrgCriteriaId: number }) {
    try {
      if (window.isOffline) {
        console.log("Offline not support for getSaleOrgCenter pls implement");
      } else {
        const url = `/api/User/SaleOrgCenter?SaleOrgCriteriaId=${params.SaleOrgCriteriaId}`;
        const res = await axios.get(url);
        return res.data;
      }
    } catch (error) {
      throw error;
    }
  }
  async getMenuCallPlan(params: any = {}) {
    try {
      if (window.isOffline) {
        console.log("Offline not support for getMenuCallPlan pls implement");
      } else {
        const url = `/api/Menu/CallPlan`;
        const res = await axios.get(url);
        return res.data;
      }
    } catch (error) {
      throw error;
    }
  }

  async getMenuTakeOrder(params: any = {}) {
    try {
      if (window.isOffline) {
        console.log("Offline not support for getMenuCallPlan pls implement");
      } else {
        const url = `/api/Menu/TakeOrder?customerId=${params.customerId}`;
        const res = await axios.get(url);
        return res.data;
      }
    } catch (error) {
      throw error;
    }
  }

  async getMenuPermission(params: { type: string }) {
    try {
      if (window.isOffline) {
        console.log("Offline not support for getMenuPermission pls implement");
      } else {
        const url = `/api/Menu/Permissions?type=${params.type}`;
        const res = await axios.get(url);
        return res.data;
      }
    } catch (error) {
      throw error;
    }
  }
}
